// @flow

import * as React from 'react';

import type { TranslatorProps } from '@gandi/translate';
import { Cell, Spinner } from '@gandi/ui';
import { ListItem } from '@gandi/ui/deprecated';

import styles from './FetchingRow.scss';

type OwnProps = {
  translator: TranslatorProps,
};

type Props = {
  ...OwnProps,
};

function FetchingRow({ translator: { __ } }: Props) {
  return (
    <ListItem>
      <Cell flex flexGrow1>
        <Spinner name="dots" variant="small" className={styles.spinner} />
        {__('We are checking if you have domains or hosting to renew.')}
      </Cell>
    </ListItem>
  );
}

const Memo: React.ComponentType<OwnProps> = React.memo<OwnProps>(FetchingRow);
Memo.displayName = 'FetchingRow';

export default Memo;
